import { CommonModule } from '@angular/common';
import { NgModule, ApplicationRef } from '@angular/core';
import { MessageDialog } from './pages/modaldialogs/messageDialog/messageDialog.component';
import { AuthDialog } from './pages/modaldialogs/authorizationDialog/authorizationDialog.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
//  import { AngularDraggableModule } from 'angular2-draggable';

// App is our top level component
import { App } from './app.component';
import { AppState, InternalStateType } from './app.service';
import { GlobalState } from './global.state';
import { PagesModule } from './pages/pages.module';
//services
import { MasterRepo } from './common/repositories';
import { AppSettings } from './common/services';
import { SettingService } from './common/services/setting.service';

import {
  CanActivateTeam,
  Permissions,
  UserToken,
  AuthService,
  CacheService,
} from './common/services/permission';
import { LoginService, LoginModule } from './pages/login';
//import { ContextMenuModule } from 'ngx-contextmenu';
import { LoginDialog } from './pages/modaldialogs/index';
//import { LoginCopy } from './pages/login/login.componentcopy';
//import { CookieService } from 'angular2-cookie/core';
import { TransactionModule } from './common/Transaction Components/transaction.module';
import { DispatchDialog } from './pages/modaldialogs/dispatchDialog/dispatchDialog.component';
import { GRNPopUpComponent } from './pages/modaldialogs/GRNDialog/GRNPopUp';
import {
  BaAmChart,
  BaBackTop,
  BaCard,
  BaCheckbox,
  BaContentTop,
  BaMenu,
  BaMenuItem,
  BaMsgCenter,
  BaMultiCheckbox,
  BaPageTop,
  BaPictureUploader,
  BaSidebar,
} from './theme/components';
import { AppRoutingModule } from './app-routing.module';
import { BaMenuService } from './theme';
import {
  DaterangepickerDirective,
  NgxDaterangepickerMd,
} from 'ngx-daterangepicker-material';
import { ReportFilterSaveDialog } from './pages/reports/components/ReportFilterSaveDialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogActions, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { CookieService } from 'ngx-cookie-service';
import { CookieInterceptor } from './common/Interceptor/CookieInterceptor';

// Application wide providers
const APP_PROVIDERS = [
  AppState,
  GlobalState,
  AuthService,
  CacheService,
  MasterRepo,
  BaMenuService,
  UserToken,
  Permissions,
  CanActivateTeam,
  SettingService,
  LoginService,
  AppSettings,
];
const NGA_COMPONENTS = [
  BaAmChart,
  BaBackTop,
  BaCard,
  // BaChartistChart,
  BaCheckbox,
  BaContentTop,
  // BaFullCalendar,
  BaMenuItem,
  BaMenu,
  BaMsgCenter,
  BaMultiCheckbox,
  BaPageTop,
  BaPictureUploader,
  BaSidebar,
];

export type StoreType = {
  state: InternalStateType;
  restoreInputValues: () => void;
  disposeOldHosts: () => void;
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [App],
  declarations: [
    LoginDialog,
    AuthDialog,
    MessageDialog,
    ReportFilterSaveDialog,
    DispatchDialog,
    App,
    GRNPopUpComponent,

    //NGA_COMPONENTS,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    PagesModule,
    NoopAnimationsModule,
    BrowserAnimationsModule,
    LoginModule,
    TransactionModule,
    CommonModule,
    AppRoutingModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  exports: [],
  providers: [
    APP_PROVIDERS,
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: CookieInterceptor, multi: true },
  ],
  entryComponents: [
    LoginDialog,
    AuthDialog,
    MessageDialog,
    DispatchDialog,
    GRNPopUpComponent,
  ],
})
export class AppModule {}
